import { addressFragment } from 'Utils/graphql-query-helper/address/addressQuery';
export const documentFragment = `{ issuingDate
  expirationDate
  nationality
  documentNumber
  issuingCountry
  birthCountry
  birthCity
  secondName
  thirdName
  fourthName
  type }`;
const profileFragment = `
  fragment BookingProfile on Profile {
    optinEmail
    optinSms
    optinPhone
    optinMail
    optinClubmedPlus
    address {
      ...Address
    }
    document {
      passport {
        ...${documentFragment}
      }
      idcard{
        ...${documentFragment}
      }
    }
    passport {
      issuingDate
      expirationDate
      nationality
      documentNumber
    }
   dateOfBirth
   civility
   mobilePhoneNumber
   identityNumber
    loyaltyProgram {
      platinumForLifeSince
      isPlatinumForLife
      points
      status
    }
   travelCompanions {
    id: customerId
    civility
    firstName
    lastName
    unicodeFirstName
    unicodeLastName
    birthdate: dateOfBirth
    document {
      passport {
        ...${documentFragment}
      }
      idcard{
        ...${documentFragment}
      }
    }
   }
  }
  ${addressFragment}
`;

/**
 * Common fields between adults and children
 * customerId is used as temp id, till being override by real proposal attendees id
 * see addSearchDataToAttendees
 *  */
const commonProfileFieldsFragment = `
  fragment CommonProfileFields on Profile {
    birthdate:dateOfBirth
    civility
    firstName
    gmNumber
    id
    lastName
    neolid:customerId
    unicodeFirstName
    unicodeLastName
  }
`;
export { profileFragment, commonProfileFieldsFragment };
